module.exports = __webpack_public_path__ + "static/img/zzrz04.e5846a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz04.jpg
// module id = RrNz
// module chunks = 1